import { Component } from '@angular/core';

@Component({
  selector: 'app-icono-candado',
  templateUrl: './icono-candado.component.html',
  styleUrls: ['./icono-candado.component.scss']
})
export class IconoCandadoComponent {

}
